module.exports = __webpack_public_path__ + "media/images/front/content/thum01-59ba20cb7021bb3d17a06f5466527032.png";